import { render, staticRenderFns } from "./InsuranceTypeCard.vue?vue&type=template&id=4b898bf5"
import script from "./InsuranceTypeCard.vue?vue&type=script&lang=js"
export * from "./InsuranceTypeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports